var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-information-component',{attrs:{"code":_vm.code,"paragraphOne":_vm.text_one,"paragraphTwo":_vm.text_two}})}
var staticRenderFns = []

export { render, staticRenderFns }